module.exports = __webpack_public_path__ + "static/media/product-layout-two.3ed322de.png";